export const LOCATIONS = {
  quickView: 'Quick View',
  header: 'Header',
  pdp: 'Product Detail Page',
  productTile: 'Product Tile',
  cart: 'Cart',
  myBag: 'My Bag',
  checkOut: 'Check Out',
  wishlist: 'Wishlist',
  content: 'Content',
  addToBagPopup: 'Add To Bag Popup',
  stores: 'Stores',
}
